enum ConversationSupervisorStep {
  Start = 0,
  SendPaymentInformation = 1,
  SendDebtOverview = 2,
  SendSelectedInvoices = 3,
  Objection = 4,
  Credit = 5,
  Postpone = 6,
  OtherReason = 7,
  Summary = 8,
}

enum ConversationSupervisorStepsGroup {
  WillPay = 0,
  HasObjection = 1,
  Credit = 2,
  Postpone = 3,
  Other = 4,
  Summary = 5,
}

export const steps = [
  // Vil betale
  { id: ConversationSupervisorStep.SendPaymentInformation, group: ConversationSupervisorStepsGroup.WillPay },
  { id: ConversationSupervisorStep.SendDebtOverview, group: ConversationSupervisorStepsGroup.WillPay },
  { id: ConversationSupervisorStep.SendSelectedInvoices, group: ConversationSupervisorStepsGroup.WillPay },
  // Annet
  { id: ConversationSupervisorStep.OtherReason, group: ConversationSupervisorStepsGroup.Other },
  // Oppsummering
  { id: ConversationSupervisorStep.Summary, group: ConversationSupervisorStepsGroup.Summary },
  // Kreditering
  { id: ConversationSupervisorStep.Credit, group: ConversationSupervisorStepsGroup.Credit },
  // Vil utsette
  { id: ConversationSupervisorStep.Postpone, group: ConversationSupervisorStepsGroup.Postpone },
  // Har innsigelse
  {id: ConversationSupervisorStep.Objection, group: ConversationSupervisorStepsGroup.HasObjection}
 ];

export { ConversationSupervisorStep as Step };
export { ConversationSupervisorStepsGroup as StepsGroup };
